const phoneNarrow = 320;
const phone = 375;
const phonePlus = 414;
const extraSmall = 420;
const extraNarrow = 440;
const narrow = 500;
const narrowPlus = 600;
const tablet = 768;
const medium = 992;
const tabletPlus = 1024;
const large = 1200;
const desktop = 1280;
const desktopWide = 1400;
const desktopLarge = 1440;
const extraLarge = 1600;
const desktopPlus = 1920;

export const breakpoint = {
    desktop,
    desktopPlus,
    desktopLarge,
    desktopWide,
    extraLarge,
    extraNarrow,
    extraSmall,
    extraWide: `(min-width: ${desktopWide}px) and (max-width: ${extraLarge}px)`,
    large,
    medium,
    mediumLarge: `(min-width: ${medium}px) and (max-width: ${large}px)`,
    mediumWide: `(min-width: ${medium}px) and (max-width: ${desktopWide}px)`,
    narrow,
    narrowPlus,
    phoneNarrow,
    phone,
    phonePlus,
    small: tablet,
    tablet,
    tabletPlus,
};
